import { IReducerAction } from './interface'
import { reducerAPILogger } from './helpers'
import { reducersAPICombined } from './reducersAPIAndInitialStates'

const reducersAPI = (state: any, typeAndPayload: IReducerAction) => {
  const { data, type } = typeAndPayload
  return process.env.ENVIRONMENT === 'development' && process.env.SHOW_REDUCERS_LOG === 'true'
    ? reducerAPILogger(typeAndPayload, reducersAPICombined, state)
    : reducersAPICombined[type](state, data)
}

export default reducersAPI
